import { select, call, takeLatest, put } from 'redux-saga/effects';
import { Toaster, Intent, Position } from '@blueprintjs/core';

import { store } from 'modules';
import * as $ui from 'modules/ui';
import { UI } from 'modules/ui';
import * as $auth from 'modules/auth';
import * as api from '../api';
import * as actions from '../actions';

const InfluencersToaster = Toaster.create({
  position: Position.BOTTOM_RIGHT,
});

const fetchInfluencers = function* ({ datasetName, pageSize, pageNumber }) {
  const token = yield select($auth.getToken);
  const publisherId = yield select($auth.getSelectedPublisherId);

  const influencers = yield call(api.fetchInfluencers, datasetName, {
    pageSize,
    pageNumber,
    token,
    publisherId,
  });

  return influencers;
};

const fetchInfluencersRequest = function* ({ payload }) {
  const { datasetName = 'influencer', pageSize, pageNumber } = payload;

  yield put($ui.setTrue(UI.Influencers.IsFetching)());

  try {
    const influencers = yield* fetchInfluencers({ datasetName, pageSize, pageNumber });
    yield put(actions.setInfluencers(influencers));
  } catch {
    InfluencersToaster.show({
      icon: 'warning-sign',
      intent: Intent.DANGER,
      message: 'Something went wrong while fetching influencers',
      action: {
        text: 'Try again',
        onClick: () => {
          store.dispatch(actions.fetchInfluencers(pageSize, pageNumber));
        },
      },
    });
  }

  yield put($ui.setFalse(UI.Influencers.IsFetching)());
};

export const fetchInfluencersSaga = function* () {
  yield takeLatest(actions.fetchInfluencers, fetchInfluencersRequest);
};
